

import axios from 'axios';

let urlApi = process.env.VUE_APP_API

if (urlApi == undefined){
  urlApi = "http://localhost:5000"
} 

const http = axios.create({
  baseURL: urlApi,  
})

http.interceptors.request.use(function (config) {
  // Do something before request is sent
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

export const getBearerToken = key => JSON.parse(localStorage.getItem(key));

export const setBearerToken = token => {
    http.defaults.headers.common['Authorization'] = `Bearer ${token}`
}


export default http